import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function CustomeTabSwitcher({ tabsArray = [], activeIndex, setActiveIndex }) {
  return (
    <Box
      display="flex"
      gap={2}
      position="relative"
      alignItems="center"
      sx={{
        background: '#93ECF636',
        borderRadius: '30px',
        padding: '4px',
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          background: 'linear-gradient(0deg,  rgba(116, 7, 118, 1) 0%,  rgba(247, 97, 250, 1) 100%)',
          height: 'calc(100% - 8px)',
          width: `calc(100% / ${tabsArray.length})`,
          transform: `translateX(${activeIndex === tabsArray.length - 1 ? activeIndex * 98 : activeIndex * 100}%)`,
          transition: 'transform 420ms cubic-bezier(0.22, 1, 0.36, 1)',
          left: 4,
          top: 4,
          borderRadius: '20px',
          boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
        }}
      />

      <Box display={'flex'} justifyContent={'space-around'} width={'100%'}>
        {tabsArray.map((e, index) => (
          <Typography
            key={e.label}
            position="relative"
            zIndex={1}
            //   px={3}
            py={1}
            variant="body2"
            sx={{
              cursor: 'pointer',
              fontWeight: activeIndex === index ? 600 : 400,
              color: activeIndex === index ? '#fff' : '#666',
              userSelect: 'none',
              transition: 'color 200ms',
            }}
            onClick={() => setActiveIndex(index)}
          >
            {e.label}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
